import config from "../../config";

const host = config.baseUrl || config["baseUrl"] || "";

export default {
  ...config,
  baseUrl: host,
  "baseUrl": host,
};
